webpackJsonp([14],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(53)(__webpack_require__(285));

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), intl$messageformat$$ = __webpack_require__(10), intl$relativeformat$$ = __webpack_require__(11), intl$format$cache$$ = __webpack_require__(35);
	
	// -----------------------------------------------------------------------------
	
	var typesSpec = {
	    locales: src$react$$["default"].PropTypes.oneOfType([
	        src$react$$["default"].PropTypes.string,
	        src$react$$["default"].PropTypes.array
	    ]),
	
	    formats : src$react$$["default"].PropTypes.object,
	    messages: src$react$$["default"].PropTypes.object
	};
	
	function assertIsDate(date, errMsg) {
	    // Determine if the `date` is valid by checking if it is finite, which is
	    // the same way that `Intl.DateTimeFormat#format()` checks.
	    if (!isFinite(date)) {
	        throw new TypeError(errMsg);
	    }
	}
	
	exports["default"] = {
	    statics: {
	        filterFormatOptions: function (obj, defaults) {
	            if (!defaults) { defaults = {}; }
	
	            return (this.formatOptions || []).reduce(function (opts, name) {
	                if (obj.hasOwnProperty(name)) {
	                    opts[name] = obj[name];
	                } else if (defaults.hasOwnProperty(name)) {
	                    opts[name] = defaults[name];
	                }
	
	                return opts;
	            }, {});
	        }
	    },
	
	    propTypes        : typesSpec,
	    contextTypes     : typesSpec,
	    childContextTypes: typesSpec,
	
	    getNumberFormat  : intl$format$cache$$["default"](Intl.NumberFormat),
	    getDateTimeFormat: intl$format$cache$$["default"](Intl.DateTimeFormat),
	    getMessageFormat : intl$format$cache$$["default"](intl$messageformat$$["default"]),
	    getRelativeFormat: intl$format$cache$$["default"](intl$relativeformat$$["default"]),
	
	    getChildContext: function () {
	        var context = this.context;
	        var props   = this.props;
	
	        return {
	            locales:  props.locales  || context.locales,
	            formats:  props.formats  || context.formats,
	            messages: props.messages || context.messages
	        };
	    },
	
	    formatDate: function (date, options) {
	        date = new Date(date);
	        assertIsDate(date, 'A date or timestamp must be provided to formatDate()');
	        return this._format('date', date, options);
	    },
	
	    formatTime: function (date, options) {
	        date = new Date(date);
	        assertIsDate(date, 'A date or timestamp must be provided to formatTime()');
	        return this._format('time', date, options);
	    },
	
	    formatRelative: function (date, options, formatOptions) {
	        date = new Date(date);
	        assertIsDate(date, 'A date or timestamp must be provided to formatRelative()');
	        return this._format('relative', date, options, formatOptions);
	    },
	
	    formatNumber: function (num, options) {
	        return this._format('number', num, options);
	    },
	
	    formatMessage: function (message, values) {
	        var locales = this.props.locales || this.context.locales;
	        var formats = this.props.formats || this.context.formats;
	
	        // When `message` is a function, assume it's an IntlMessageFormat
	        // instance's `format()` method passed by reference, and call it. This
	        // is possible because its `this` will be pre-bound to the instance.
	        if (typeof message === 'function') {
	            return message(values);
	        }
	
	        if (typeof message === 'string') {
	            message = this.getMessageFormat(message, locales, formats);
	        }
	
	        return message.format(values);
	    },
	
	    getIntlMessage: function (path) {
	        var messages  = this.props.messages || this.context.messages;
	        var pathParts = path.split('.');
	
	        var message;
	
	        try {
	            message = pathParts.reduce(function (obj, pathPart) {
	                return obj[pathPart];
	            }, messages);
	        } finally {
	            if (message === undefined) {
	                throw new ReferenceError('Could not find Intl message: ' + path);
	            }
	        }
	
	        return message;
	    },
	
	    getNamedFormat: function (type, name) {
	        var formats = this.props.formats || this.context.formats;
	        var format  = null;
	
	        try {
	            format = formats[type][name];
	        } finally {
	            if (!format) {
	                throw new ReferenceError(
	                    'No ' + type + ' format named: ' + name
	                );
	            }
	        }
	
	        return format;
	    },
	
	    _format: function (type, value, options, formatOptions) {
	        var locales = this.props.locales || this.context.locales;
	
	        if (options && typeof options === 'string') {
	            options = this.getNamedFormat(type, options);
	        }
	
	        switch(type) {
	            case 'date':
	            case 'time':
	                return this.getDateTimeFormat(locales, options).format(value);
	            case 'number':
	                return this.getNumberFormat(locales, options).format(value);
	            case 'relative':
	                return this.getRelativeFormat(locales, options).format(value, formatOptions);
	            default:
	                throw new Error('Unrecognized format type: ' + type);
	        }
	    }
	};
	
	//# sourceMappingURL=mixin.js.map

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	/* global React */
	/* jshint esnext:true */
	
	// TODO: Remove the global `React` binding lookup once the ES6 Module Transpiler
	// supports external modules. This is a hack for now that provides the local
	// modules a referece to React.
	"use strict";
	exports["default"] = React;
	
	//# sourceMappingURL=react.js.map

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* jshint node:true */
	'use strict';
	
	// Expose `React` as a global, because the ReactIntlMixin assumes it's global.
	var oldReact = global.React;
	global.React = __webpack_require__(1);
	
	// Require the lib and add all locale data to `ReactIntl`. This module will be
	// ignored when bundling for the browser with Browserify/Webpack.
	var ReactIntl = __webpack_require__(34);
	__webpack_require__(40);
	
	// Export the Mixin as the default export for back-compat with v1.0.0. This will
	// be changed to simply re-exporting `ReactIntl` as the default export in v2.0.
	exports = module.exports = ReactIntl.IntlMixin;
	
	// Define non-enumerable expandos for each named export on the default export --
	// which is the Mixin for back-compat with v1.0.0.
	Object.keys(ReactIntl).forEach(function (namedExport) {
	    Object.defineProperty(exports, namedExport, {
	        enumerable: true,
	        value     : ReactIntl[namedExport]
	    });
	});
	
	// Put back `global.React` to how it was.
	if (oldReact) {
	    global.React = oldReact;
	} else {
	    // IE < 9 will throw when trying to delete something off the global object,
	    // `window`, so this does the next best thing as sets it to `undefined`.
	    try {
	        delete global.React;
	    } catch (e) {
	        global.React = undefined;
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(25)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(39);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(10), src$diff$$ = __webpack_require__(22), src$es5$$ = __webpack_require__(24);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45,  // seconds to minute
	        minute: 45,  // minutes to hour
	        hour  : 22,  // hours to day
	        day   : 26,  // days to month
	        month : 11   // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	
	    for (i = 0, l = FIELDS.length; i < l; i += 1) {
	        units = FIELDS[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond: millisecond,
	        second     : second,
	        minute     : minute,
	        hour       : hour,
	        day        : day,
	        week       : week,
	        month      : month,
	        year       : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"Year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"Month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"Day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"Hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"Minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"Second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(21), src$en$$ = __webpack_require__(23);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$mixin$$ = __webpack_require__(4);
	
	var FormattedDate = src$react$$["default"].createClass({
	    displayName: 'FormattedDate',
	    mixins     : [src$mixin$$["default"]],
	
	    statics: {
	        formatOptions: [
	            'localeMatcher', 'timeZone', 'hour12', 'formatMatcher', 'weekday',
	            'era', 'year', 'month', 'day', 'hour', 'minute', 'second',
	            'timeZoneName'
	        ]
	    },
	
	    propTypes: {
	        format: src$react$$["default"].PropTypes.string,
	        value : src$react$$["default"].PropTypes.any.isRequired
	    },
	
	    render: function () {
	        var props    = this.props;
	        var value    = props.value;
	        var format   = props.format;
	        var defaults = format && this.getNamedFormat('date', format);
	        var options  = FormattedDate.filterFormatOptions(props, defaults);
	
	        return src$react$$["default"].DOM.span(null, this.formatDate(value, options));
	    }
	});
	
	exports["default"] = FormattedDate;
	
	//# sourceMappingURL=date.js.map

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$escape$$ = __webpack_require__(33), src$mixin$$ = __webpack_require__(4);
	
	var FormattedHTMLMessage = src$react$$["default"].createClass({
	    displayName: 'FormattedHTMLMessage',
	    mixins     : [src$mixin$$["default"]],
	
	    propTypes: {
	        tagName: src$react$$["default"].PropTypes.string,
	        message: src$react$$["default"].PropTypes.string.isRequired
	    },
	
	    getDefaultProps: function () {
	        return {tagName: 'span'};
	    },
	
	    render: function () {
	        var props   = this.props;
	        var tagName = props.tagName;
	        var message = props.message;
	
	        // Process all the props before they are used as values when formatting
	        // the ICU Message string. Since the formatted message will be injected
	        // via `innerHTML`, all String-based values need to be HTML-escaped. Any
	        // React Elements that are passed as props will be rendered to a static
	        // markup string that is presumed to be safe.
	        var values = Object.keys(props).reduce(function (values, name) {
	            var value = props[name];
	
	            if (typeof value === 'string') {
	                value = src$escape$$["default"](value);
	            } else if (src$react$$["default"].isValidElement(value)) {
	                value = src$react$$["default"].renderToStaticMarkup(value);
	            }
	
	            values[name] = value;
	            return values;
	        }, {});
	
	        // Since the message presumably has HTML in it, we need to set
	        // `innerHTML` in order for it to be rendered and not escaped by React.
	        // To be safe, all string prop values were escaped before formatting the
	        // message. It is assumed that the message is not UGC, and came from
	        // the developer making it more like a template.
	        //
	        // Note: There's a perf impact of using this component since there's no
	        // way for React to do its virtual DOM diffing.
	        return src$react$$["default"].DOM[tagName]({
	            dangerouslySetInnerHTML: {
	                __html: this.formatMessage(message, values)
	            }
	        });
	    }
	});
	
	exports["default"] = FormattedHTMLMessage;
	
	//# sourceMappingURL=html-message.js.map

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$mixin$$ = __webpack_require__(4);
	
	var FormattedMessage = src$react$$["default"].createClass({
	    displayName: 'FormattedMessage',
	    mixins     : [src$mixin$$["default"]],
	
	    propTypes: {
	        tagName: src$react$$["default"].PropTypes.string,
	        message: src$react$$["default"].PropTypes.string.isRequired
	    },
	
	    getDefaultProps: function () {
	        return {tagName: 'span'};
	    },
	
	    render: function () {
	        var props   = this.props;
	        var tagName = props.tagName;
	        var message = props.message;
	
	        // Creates a token with a random guid that should not be guessable or
	        // conflict with other parts of the `message` string.
	        var guid       = Math.floor(Math.random() * 0x10000000000).toString(16);
	        var tokenRegex = new RegExp('(@__ELEMENT-' + guid + '-\\d+__@)', 'g');
	        var elements   = {};
	
	        var generateToken = (function () {
	            var counter = 0;
	            return function () {
	                return '@__ELEMENT-' + guid + '-' + (counter += 1) + '__@';
	            };
	        }());
	
	        // Iterates over the `props` to keep track of any React Element values
	        // so they can be represented by the `token` as a placeholder when the
	        // `message` is formatted. This allows the formatted message to then be
	        // broken-up into parts with references to the React Elements inserted
	        // back in.
	        var values = Object.keys(props).reduce(function (values, name) {
	            var value = props[name];
	            var token;
	
	            if (src$react$$["default"].isValidElement(value)) {
	                token           = generateToken();
	                values[name]    = token;
	                elements[token] = value;
	            } else {
	                values[name] = value;
	            }
	
	            return values;
	        }, {});
	
	        // Formats the `message` with the `values`, including the `token`
	        // placeholders for React Element values.
	        var formattedMessage = this.formatMessage(message, values);
	
	        // Split the message into parts so the React Element values captured
	        // above can be inserted back into the rendered message. This
	        // approach allows messages to render with React Elements while keeping
	        // React's virtual diffing working properly.
	        var children = formattedMessage.split(tokenRegex)
	            .filter(function (part) {
	                // Ignore empty string parts.
	                return !!part;
	            })
	            .map(function (part) {
	                // When the `part` is a token, get a ref to the React Element.
	                return elements[part] || part;
	            });
	
	        var elementArgs = [tagName, null].concat(children);
	        return src$react$$["default"].createElement.apply(null, elementArgs);
	    }
	});
	
	exports["default"] = FormattedMessage;
	
	//# sourceMappingURL=message.js.map

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$mixin$$ = __webpack_require__(4);
	
	var FormattedNumber = src$react$$["default"].createClass({
	    displayName: 'FormattedNumber',
	    mixins     : [src$mixin$$["default"]],
	
	    statics: {
	        formatOptions: [
	            'localeMatcher', 'style', 'currency', 'currencyDisplay',
	            'useGrouping', 'minimumIntegerDigits', 'minimumFractionDigits',
	            'maximumFractionDigits', 'minimumSignificantDigits',
	            'maximumSignificantDigits'
	        ]
	    },
	
	    propTypes: {
	        format: src$react$$["default"].PropTypes.string,
	        value : src$react$$["default"].PropTypes.any.isRequired
	    },
	
	    render: function () {
	        var props    = this.props;
	        var value    = props.value;
	        var format   = props.format;
	        var defaults = format && this.getNamedFormat('number', format);
	        var options  = FormattedNumber.filterFormatOptions(props, defaults);
	
	        return src$react$$["default"].DOM.span(null, this.formatNumber(value, options));
	    }
	});
	
	exports["default"] = FormattedNumber;
	
	//# sourceMappingURL=number.js.map

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$mixin$$ = __webpack_require__(4);
	
	var FormattedRelative = src$react$$["default"].createClass({
	    displayName: 'FormattedRelative',
	    mixins     : [src$mixin$$["default"]],
	
	    statics: {
	        formatOptions: [
	            'style', 'units'
	        ]
	    },
	
	    propTypes: {
	        format: src$react$$["default"].PropTypes.string,
	        value : src$react$$["default"].PropTypes.any.isRequired,
	        now   : src$react$$["default"].PropTypes.any
	    },
	
	    render: function () {
	        var props    = this.props;
	        var value    = props.value;
	        var format   = props.format;
	        var defaults = format && this.getNamedFormat('relative', format);
	        var options  = FormattedRelative.filterFormatOptions(props, defaults);
	
	        var formattedRelativeTime = this.formatRelative(value, options, {
	            now: props.now
	        });
	
	        return src$react$$["default"].DOM.span(null, formattedRelativeTime);
	    }
	});
	
	exports["default"] = FormattedRelative;
	
	//# sourceMappingURL=relative.js.map

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$mixin$$ = __webpack_require__(4);
	
	var FormattedTime = src$react$$["default"].createClass({
	    displayName: 'FormattedTime',
	    mixins     : [src$mixin$$["default"]],
	
	    statics: {
	        formatOptions: [
	            'localeMatcher', 'timeZone', 'hour12', 'formatMatcher', 'weekday',
	            'era', 'year', 'month', 'day', 'hour', 'minute', 'second',
	            'timeZoneName'
	        ]
	    },
	
	    propTypes: {
	        format: src$react$$["default"].PropTypes.string,
	        value : src$react$$["default"].PropTypes.any.isRequired
	    },
	
	    render: function () {
	        var props    = this.props;
	        var value    = props.value;
	        var format   = props.format;
	        var defaults = format && this.getNamedFormat('time', format);
	        var options  = FormattedTime.filterFormatOptions(props, defaults);
	
	        return src$react$$["default"].DOM.span(null, this.formatTime(value, options));
	    }
	});
	
	exports["default"] = FormattedTime;
	
	//# sourceMappingURL=time.js.map

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"Year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"Month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"Day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"Hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"Minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"Second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	/* jshint esnext:true */
	
	/*
	HTML escaping implementation is the same as React's (on purpose.) Therefore, it
	has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	"use strict";
	var ESCAPED_CHARS = {
	    '&' : '&amp;',
	    '>' : '&gt;',
	    '<' : '&lt;',
	    '"' : '&quot;',
	    '\'': '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	exports["default"] = function (str) {
	    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	        return ESCAPED_CHARS[match];
	    });
	};
	
	//# sourceMappingURL=escape.js.map

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	/* jshint esnext: true */
	
	"use strict";
	exports.__addLocaleData = __addLocaleData;
	var intl$messageformat$$ = __webpack_require__(10), intl$relativeformat$$ = __webpack_require__(11), src$en$$ = __webpack_require__(32), src$mixin$$ = __webpack_require__(4), src$components$date$$ = __webpack_require__(26), src$components$time$$ = __webpack_require__(31), src$components$relative$$ = __webpack_require__(30), src$components$number$$ = __webpack_require__(29), src$components$message$$ = __webpack_require__(28), src$components$html$message$$ = __webpack_require__(27);
	function __addLocaleData(data) {
	    intl$messageformat$$["default"].__addLocaleData(data);
	    intl$relativeformat$$["default"].__addLocaleData(data);
	}
	
	__addLocaleData(src$en$$["default"]);
	exports.IntlMixin = src$mixin$$["default"], exports.FormattedDate = src$components$date$$["default"], exports.FormattedTime = src$components$time$$["default"], exports.FormattedRelative = src$components$relative$$["default"], exports.FormattedNumber = src$components$number$$["default"], exports.FormattedMessage = src$components$message$$["default"], exports.FormattedHTMLMessage = src$components$html$message$$["default"];
	
	//# sourceMappingURL=react-intl.js.map

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(37)['default'];
	exports['default'] = exports;


/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var src$es5$$ = __webpack_require__(36);
	exports["default"] = createFormatCache;
	
	// -----------------------------------------------------------------------------
	
	function createFormatCache(FormatConstructor) {
	    var cache = src$es5$$.objCreate(null);
	
	    return function () {
	        var args    = Array.prototype.slice.call(arguments);
	        var cacheId = getCacheId(args);
	        var format  = cacheId && cache[cacheId];
	
	        if (!format) {
	            format = src$es5$$.objCreate(FormatConstructor.prototype);
	            FormatConstructor.apply(format, args);
	
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	
	        return format;
	    };
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function getCacheId(inputs) {
	    // When JSON is not available in the runtime, we will not create a cache id.
	    if (typeof JSON === 'undefined') { return; }
	
	    var cacheId = [];
	
	    var i, len, input;
	
	    for (i = 0, len = inputs.length; i < len; i += 1) {
	        input = inputs[i];
	
	        if (input && typeof input === 'object') {
	            cacheId.push(orderedProps(input));
	        } else {
	            cacheId.push(input);
	        }
	    }
	
	    return JSON.stringify(cacheId);
	}
	
	function orderedProps(obj) {
	    var props = [],
	        keys  = [];
	
	    var key, i, len, prop;
	
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	        }
	    }
	
	    var orderedKeys = keys.sort();
	
	    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
	        key  = orderedKeys[i];
	        prop = {};
	
	        prop[key] = obj[key];
	        props[i]  = prop;
	    }
	
	    return props;
	}
	
	//# sourceMappingURL=memoizer.js.map

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var $ = __webpack_require__(50);
	var FormattedHTMLMessage = __webpack_require__(6).FormattedHTMLMessage;
	var i18n = __webpack_require__(2);
	var Analytics = __webpack_require__(3);
	var ReactCSSTransitionGroup = __webpack_require__(115);
	
	var FEATURES_KEYS_PREFIX = 'fees.feature.';
	var FEATURES_KEYS = ['no_fees', 'free_direct_deposit', 'free_withdrawals', 'load_cash'];
	
	var TABLE_KEYS_PREFIX = 'fees.table.';
	var TABLE_HEADERS_KEYS = ['all_fees', 'amount', 'details'];
	var TABLE_DETAILS_KEYS_SUFFIX = ['.name', '.amount', '.details'];
	var TABLE_HEADERS_KEYS_SUFFIX = '.header';
	
	var FeesPage = React.createClass({
	    displayName: 'FeesPage',
	
	    mixins: [i18n('common/fees')],
	
	    propTypes: {
	        dailyLimit: React.PropTypes.object.isRequired,
	        monthlyLimit: React.PropTypes.object.isRequired
	    },
	
	    // Scroll to top functionality
	    getInitialState: function getInitialState() {
	        return { isBackToTopButtonVisible: false };
	    },
	
	    setBackToTopButtonVisibility: function setBackToTopButtonVisibility() {
	        var isBackToTopButtonVisible = this.feesPageContainer.getBoundingClientRect().top < 0;
	
	        this.setState({
	            isBackToTopButtonVisible: isBackToTopButtonVisible
	        });
	    },
	
	    componentDidMount: function componentDidMount() {
	        Analytics.trackPage({ id: 'fees', data: this.props });
	        window.addEventListener('scroll', this.setBackToTopButtonVisibility);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        window.removeEventListener('scroll', this.setBackToTopButtonVisibility);
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        return nextState.isBackToTopButtonVisible !== this.state.isBackToTopButtonVisible;
	    },
	
	    backToTop: function backToTop(event) {
	        event.preventDefault();
	        $('html, body').animate({ scrollTop: 0 }, 500);
	    },
	
	    renderBackToTop: function renderBackToTop() {
	        var button = React.createElement(
	            'div',
	            { key: 'backToTop', onClick: this.backToTop, className: 'vx_btn vx_btn-medium terms-back-to-top-btn' },
	            this.i18n('fees.backToTop')
	        );
	
	        return React.createElement(
	            ReactCSSTransitionGroup,
	            {
	                transitionName: 'backToTopButton',
	                transitionEnterTimeout: 500,
	                transitionLeaveTimeout: 500
	            },
	            this.state.isBackToTopButtonVisible && button
	        );
	    },
	
	    // Content layout
	    renderHeader: function renderHeader() {
	        return React.createElement(
	            'header',
	            { className: 'vx_modal-header text-center' },
	            React.createElement(
	                'h2',
	                { className: 'fees-header vx_h2' },
	                this.i18n('fees.header')
	            )
	        );
	    },
	
	    renderSubheader: function renderSubheader() {
	        return React.createElement(
	            'h3',
	            { className: 'fees-subheader text-center vx_h3' },
	            this.i18n('fees.subheader')
	        );
	    },
	
	    renderCheckmark: function renderCheckmark() {
	        return React.createElement('i', { className: 'icon icon-circled-checkmark-small fees-green-checkmark' });
	    },
	
	    renderFeaturesTable: function renderFeaturesTable() {
	        var i18n = this.i18n;
	        var checkmark = this.renderCheckmark();
	
	        var featuresContent = FEATURES_KEYS.map(function (i) {
	            var propKey = FEATURES_KEYS_PREFIX + i;
	            return React.createElement(
	                'tr',
	                { key: propKey },
	                React.createElement(
	                    'td',
	                    null,
	                    checkmark
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    i18n(propKey)
	                )
	            );
	        });
	
	        return React.createElement(
	            'table',
	            { className: 'fees-features-table' },
	            React.createElement(
	                'tbody',
	                null,
	                featuresContent
	            )
	        );
	    },
	
	    renderFeesTable: function renderFeesTable() {
	        var i18n = this.i18n;
	
	        var headers = React.createElement(
	            'tbody',
	            null,
	            React.createElement(
	                'tr',
	                null,
	                TABLE_HEADERS_KEYS.map(function (i) {
	                    var propKey = TABLE_KEYS_PREFIX + i + TABLE_HEADERS_KEYS_SUFFIX;
	                    return React.createElement(
	                        'th',
	                        { className: 'fees-table-main-heading', key: propKey },
	                        ' ',
	                        i18n(propKey),
	                        ' '
	                    );
	                })
	            )
	        );
	
	        var generateDetailsHeader = function generateDetailsHeader(groupName) {
	            return React.createElement(
	                'tr',
	                null,
	                React.createElement(
	                    'th',
	                    { className: 'fees-table-sub-heading', colSpan: '3' },
	                    i18n(TABLE_KEYS_PREFIX + groupName + TABLE_HEADERS_KEYS_SUFFIX),
	                    ' '
	                )
	            );
	        };
	
	        var generateDetailsRow = function generateDetailsRow(groupName, rowName) {
	            var propKeyPrefix = TABLE_KEYS_PREFIX + groupName + '.' + rowName;
	            return React.createElement(
	                'tr',
	                { key: propKeyPrefix },
	                TABLE_DETAILS_KEYS_SUFFIX.map(function (i) {
	                    var propKey = propKeyPrefix + i;
	                    return React.createElement(
	                        'td',
	                        { key: propKey },
	                        React.createElement(FormattedHTMLMessage, { message: i18n(propKey) })
	                    );
	                })
	            );
	        };
	
	        var generateGroup = function generateGroup(groupName, rowNameList) {
	            return React.createElement(
	                'tbody',
	                { key: groupName },
	                generateDetailsHeader(groupName),
	                rowNameList.map(function (rowName) {
	                    return generateDetailsRow(groupName, rowName);
	                })
	            );
	        };
	
	        var groupCashLoads = React.createElement(
	            'tbody',
	            { key: 'cash_load' },
	            generateDetailsHeader('cash_load'),
	            React.createElement(
	                'tr',
	                { key: 'fees.table.cash_load.daily' },
	                React.createElement(
	                    'td',
	                    null,
	                    i18n('fees.table.cash_load.daily.name')
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    this.props.dailyLimit
	                ),
	                React.createElement(
	                    'td',
	                    { rowSpan: '2' },
	                    React.createElement(FormattedHTMLMessage, { message: i18n('fees.table.cash_load.daily_monthly.details', { dailyLimit: this.props.dailyLimit, monthlyLimit: this.props.monthlyLimit }) })
	                )
	            ),
	            React.createElement(
	                'tr',
	                { key: 'fees.table.cash_load.monthly' },
	                React.createElement(
	                    'td',
	                    null,
	                    i18n('fees.table.cash_load.monthly.name')
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    this.props.monthlyLimit
	                )
	            )
	        );
	
	        return React.createElement(
	            'table',
	            null,
	            headers,
	            generateGroup('get_started', ['card_fee']),
	            generateGroup('monthly_usage', ['monthly_fee', 'inactivity']),
	            generateGroup('add_money', ['load_cash_using_app', 'load_cash_using_cash_card', 'direct_deposit', 'transfer', 'receive', 'check_cashed', 'check_cashing_payroll_gov', 'check_cashing_others']),
	            generateGroup('spend_money', ['cash_card_purchases']),
	            generateGroup('declined_trans', ['spending_declined', 'atm_declined']),
	            generateGroup('withdrawals', ['in_network_atm', 'out_network_atm', 'bank_counter']),
	            generateGroup('usage_limits', ['daily_atm', 'daily_purchase']),
	            generateGroup('outside_us', ['international_transaction', 'interational_atm']),
	            generateGroup('processing_policies', ['negative_balance', 'card_replacement_std']),
	            generateGroup('goals', ['create', 'transfer']),
	            generateGroup('sending_money', ['send_from_ppbalance']),
	            groupCashLoads
	        );
	    },
	
	    renderFooter: function renderFooter() {
	        var i18n = this.i18n;
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'div',
	                { className: 'vx_text-body_secondary' },
	                React.createElement(FormattedHTMLMessage, { message: i18n('fee.footer.about_trems') })
	            ),
	            React.createElement('br', null),
	            React.createElement(
	                'div',
	                { className: 'vx_text-body_secondary' },
	                React.createElement(FormattedHTMLMessage, { message: i18n('fees.footer.about_ppcashcard') })
	            ),
	            React.createElement('br', null),
	            React.createElement(
	                'div',
	                { className: 'vx_text-body_secondary' },
	                React.createElement(FormattedHTMLMessage, { message: i18n('fees.footer.about_debit_benefits') })
	            )
	        );
	    },
	
	    render: function render() {
	        var _this = this;
	
	        return React.createElement(
	            'div',
	            { className: 'fees-page vx_modal-content', id: 'fees-page', ref: function ref(e) {
	                    _this.feesPageContainer = e;
	                } },
	            this.renderHeader(),
	            this.renderSubheader(),
	            React.createElement(
	                'div',
	                { className: 'fees-image-features-container' },
	                React.createElement(
	                    'div',
	                    { className: 'fees-image-left' },
	                    React.createElement('img', { src: 'https://www.paypalobjects.com/digitalassets/c/consumer/bundle/paypal-cashcard-withphone.png',
	                        srcSet: 'https://www.paypalobjects.com/digitalassets/c/consumer/bundle/paypal-cashcard-withphone.png 1x, https://www.paypalobjects.com/digitalassets/c/consumer/bundle/paypal-cashcard-withphone_2x.png 2x' })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'fees-features-right' },
	                    this.renderFeaturesTable()
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'fees-table-container' },
	                this.renderFeesTable()
	            ),
	            this.renderFooter(),
	            this.renderBackToTop()
	        );
	    }
	});
	
	module.exports = FeesPage;

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var FeesPage = __webpack_require__(109);
	
	var RootComponent = React.createClass({
	    displayName: 'RootComponent',
	
	
	    propTypes: {
	        renderCurrentPage: React.PropTypes.func.isRequired,
	        section: React.PropTypes.string,
	        dailyLimit: React.PropTypes.string.isRequired,
	        monthlyLimit: React.PropTypes.string.isRequired
	    },
	
	    render: function render() {
	        return this.props.renderCurrentPage({
	            section: this.props.section,
	            dailyLimit: this.props.dailyLimit,
	            monthlyLimit: this.props.monthlyLimit
	        });
	    }
	});
	
	RootComponent.getFlowProps = function () {
	    return {
	        startPage: FeesPage,
	        terminalPages: [FeesPage],
	        hideFeedbackLink: [FeesPage]
	    };
	};
	
	module.exports = RootComponent;

/***/ })

});


// WEBPACK FOOTER //
// fees.js